import React, { createRef, useEffect, useRef, useState } from "react";
import { specializations } from "./data/specializations.data";
import { Header } from "./components/header.component";
import { Row } from "./components/row.component";
import { Divider } from "./components/divider.component";
import { Box } from "./components/box.component";
import { Paragraph } from "./components/paragraph.component";
import { Button } from "./components/button.component";
import { ListItem } from "./components/list-item.component";
import { Progress } from "./components/progress.component";
import { experiences } from "./data/experiences.data";
import { Image } from "./components/image.component";
import Spinner from "./components/spinner.component";
import { certifications } from "./data/certifications.data";
import { languages } from "./data/languages.data";
import { contacts } from "./data/contacts.data";
import icon from "./assets/favicon.png";
function App() {
  const [isLoading, setIsloading] = useState(true);
  const [openSpecialization, setOpenSpecialization] = useState(0);
  const [openExperience, setOpenExperience] = useState(0);
  const [theme, setTheme] = useState(localStorage.getItem("theme") ?? "dark");
  const stickyElements = useRef(
    specializations
      .map(() => createRef())
      .concat(experiences.map(() => createRef()))
  );
  const handleScroll = () => {
    stickyElements.current.forEach((element) => {
      const rect = element.current.getBoundingClientRect();
      let id;
      if (rect.top <= 190) {
        if (element.current.id.includes("specialization")) {
          id = Number(element.current.id.replace("specialization_", ""));
          setOpenSpecialization(id);
        }
        if (element.current.id.includes("experience")) {
          id = Number(element.current.id.replace("experience_", ""));
          setOpenExperience(id);
        }
      }
    });
  };
  const scrollToTargetAdjusted = (element) => {
    var headerOffset = 190;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };
  const handleOpenSpecialization = (specialization, element) => {
    if (window.innerWidth <= 480) {
      scrollToTargetAdjusted(element.current);
    } else {
      setOpenSpecialization(specialization.id);
    }
  };
  const handleOpenExperience = (experience, element) => {
    if (window.innerWidth <= 480) {
      scrollToTargetAdjusted(element.current);
    } else {
      setOpenExperience(experience.id);
    }
  };
  useEffect(() => {
    const htmlElement = document.querySelector("html");
    if (theme === "dark") {
      if (htmlElement.classList.contains("light")) {
        htmlElement.classList.remove("light");
      }
    }
    if (theme === "light") {
      if (htmlElement.classList.contains("dark")) {
        htmlElement.classList.remove("dark");
      }
    }
    htmlElement.classList.add(theme);
  }, [theme]);
  useEffect(() => {
    if (window.innerWidth <= 480) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const timeOutFunc = () => {
      setIsloading(false);
    };
    if (isLoading) {
      setTimeout(timeOutFunc, 1100);
    } else {
      clearTimeout(timeOutFunc);
    }
  }, [isLoading]);

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <Header setTheme={setTheme} theme={theme} />
      <main className="flex flex-col mt-4 lg:m-4 relative">
        <Box>
          <Row gap={4} className="flex-wrap text-left">
            <Image src={"/favicon.ico"} size="2xl" rounded="full" className="basis-60" /> 
            <Row direction="col" gap={4}>
              <Paragraph
                size="lg"
                weight="medium"
                className="dark:text-gray-50" 
              >
                <strong>Software</strong> is emerging as the new cornerstone of order across the
                economy, society, and politics, playing a pivotal role wherever
                processes can be automated.
              </Paragraph>

              <Paragraph
                size="lg"
                weight="medium"
                className="dark:text-gray-50"
              >
                A self-taught <strong>software engineer</strong>, passionate about software from
                a young age, I have over 7 years of experience by the age of 28.
                I specialize in creating and maintaining products and web
                applications that provide structure for organizations,
                companies, startups, and individuals.
              </Paragraph>
            </Row>
          </Row>
        </Box>

        <Row
          className="py-8 sticky top-[113px] z-20 bg-gray-100 dark:bg-gray-900 dark:text-gray-50"
          justify="center"
        >
          <Divider>My experties lies in</Divider>
        </Row>
        <Row items="start" className="flex-wrap relative">
          {specializations.map((specialization, index) => (
            <Row
              ref={stickyElements.current[index]}
              id={`specialization_${specialization.id}`}
              direction="col"
              items="start"
              justify="start"
              className="flex-1 basis-60 "
            >
              <Button
                onClick={() =>
                  handleOpenSpecialization(
                    specialization,
                    stickyElements.current[index]
                  )
                }
                isActive={openSpecialization === specialization.id}
                className="sticky top-[205px]  w-full "
              >
                {specialization.name}
              </Button>
              <Box
                padding={2}
                onClick={() =>
                  handleOpenSpecialization(
                    specialization,
                    stickyElements.current[index]
                  )
                }
                isActive={openSpecialization === specialization.id}
                cursor="pointer"
                className="w-full"
              >
                {specialization.children.map((child) => (
                  <ListItem>
                    <Row justify="between">
                      <span className="text-blue-600 dark:text-blue-400 pl-2 lg:pl-0">
                        {child.name}
                      </span>
                    </Row>

                    {child.children.map((child) => (
                      <Row
                        className="ml-6 lg:ml-4 text-sm text-gray-800 dark:text-gray-200"
                        justify="between"
                      >
                        <span className="flex-1">{child.name}</span>
                        {child.progress > 0 && (
                          <Progress progress={child.progress} />
                        )}
                      </Row>
                    ))}
                  </ListItem>
                ))}
              </Box>
            </Row>
          ))}
        </Row>
        <Row className="py-8 sticky top-[113px]  z-20 bg-gray-100 dark:bg-gray-900 dark:text-gray-50">
          <Divider>I have worked with</Divider>
        </Row>
        <Row items="start" className="flex-wrap">
          {experiences.map((experience, index) => (
            <Row
              ref={stickyElements.current[index + specializations.length]}
              id={`experience_${experience.id}`}
              direction="col"
              items="start"
              justify="start"
              className="flex-1 basis-60"
            >
              <Button
                onClick={() =>
                  handleOpenExperience(
                    experience,
                    stickyElements.current[index + specializations.length]
                  )
                }
                isActive={openExperience === experience.id}
                className="sticky top-[205px] w-full"
              >
                <Row justify="between">
                  <span>{experience.name}</span>
                  {experience.year && (
                    <span className=" text-xs font-thin">
                      {experience.year}
                    </span>
                  )}
                </Row>
              </Button>
              <Box
                padding={2}
                onClick={() =>
                  handleOpenExperience(
                    experience,
                    stickyElements.current[index + specializations.length]
                  )
                }
                isActive={openExperience === experience.id}
                cursor="pointer"
              >
                {experience.children.map((child) => (
                  <ListItem>
                    <Paragraph className="dark:text-gray-200">
                      {child.name}
                    </Paragraph>
                    <Row
                      direction="row"
                      justify="start"
                      className="flex-wrap mt-2"
                    >
                      {child.technologies.map((techonology) => (
                        <Row
                          direction="row"
                          className="text-sm flex-1  bg-gray-200 px-4 py-2 rounded-lg basis-auto dark:bg-gray-700"
                          justify="between"
                        >
                          <Image
                            src={techonology.logo}
                            alt={techonology.name}
                            size="sm"
                            rounded="full"
                          />
                          <span className="flex-1 text-gray-800 dark:text-gray-100">
                            {techonology.name}
                          </span>
                        </Row>
                      ))}
                    </Row>
                  </ListItem>
                ))}
              </Box>
            </Row>
          ))}
        </Row>

        <Row className="flex-wrap z-40 mt-4" justify="between" items="stretch">
          <Box className="flex-1  basis-[360px] lg:basis-[45%]">
            <h2 className="dark:text-gray-50 p-4 pl-0 text-2xl font-semibold">
              Certified with
            </h2>

            <Row items="start" className="flex-wrap">
              {certifications.map((certification) => (
                <Box key={certification.id} className="flex-1 w-full basis-60 border-b border-gray-200 dark:border-gray-700 last-of-type:border-none">
                  <Row justify="between">
                    <Row>
                      {certification.logo && (
                        <Row className="p-2 bg-white rounded-full self-start flex-0">
                          <Image size="sm" src={certification.logo} />
                        </Row>
                      )}
                      <Paragraph className="dark:text-gray-50 font-semibold">
                        {certification.name}
                      </Paragraph>
                    </Row>
                    <Row>
                      {certification.link && (
                        <a
                          href={certification.link}
                          target="_BLANK"
                          rel={"noreferrer"}
                        >
                          <svg
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            fill={"none"}
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g id="Interface / External_Link">
                              <path
                                id="Vector"
                                d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
                                stroke={theme === "light" ? "#000" : "#fff"}
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                          </svg>
                        </a>
                      )}
                      <Paragraph className="dark:text-gray-200 font-light text-xs">
                        {certification.year}
                      </Paragraph>
                    </Row>
                  </Row>
                </Box>
              ))}
            </Row>
          </Box>
          <Box className="flex-1 basis-[360px] lg:basis-[45%]">
            <h2 className="dark:text-gray-50 p-4 pl-0 text-2xl font-semibold">
              Speaks in
            </h2>

            <Row items="start" className="flex-wrap">
              {languages.map((language) => (
                <Box key={language.id} className="flex-1 w-full basis-60 border-b border-gray-200 dark:border-gray-700 last-of-type:border-none">
                  <Row justify="between">
                    <Paragraph className="dark:text-gray-50 font-light">
                      {language.name}
                    </Paragraph>
                    <Paragraph className="dark:text-gray-50 font-semibold">
                      {language.level}
                    </Paragraph>
                  </Row>
                </Box>
              ))}
            </Row>
          </Box>
          <Box className="sm:p-0 !bg-transparent !border-none flex-1 basis-[360px] lg:basis-[45%]">
            <h2 className="dark:text-gray-50 p-4 pl-0 text-2xl font-semibold">
              You can reach me at
            </h2>

            <Row items="stretch" className="flex-wrap">
              {contacts.map((contact) => (
                <Box key={contact.id} className="flex-1 w-full basis-[280px] md:basis-[45%] xl:basis-[23%]">
                  <Row justify="between">
                    <Row className="basis-28" justify="start">
                      <Image
                        src={contact.logo}
                        alt={contact.name}
                        size="sm"
                        rounded="full"
                      />

                      <Paragraph className="dark:text-gray-50 font-light">
                        {contact.name}
                      </Paragraph>
                    </Row>
                    {contact.type === "mail" && (
                      <a
                        href={"mailto:" + contact.value}
                        className="dark:text-gray-200 font-regular text-sm text-right"
                      >
                        {contact.value}
                      </a>
                    )}
                    {contact.type === "phone" && (
                      <a
                        href={"phone:" + contact.value}
                        className="dark:text-gray-200 font-regular text-sm"
                      >
                        {contact.value}
                      </a>
                    )}
                    {contact.type === "link" && (
                      <a
                        target="_BLANK"
                        rel={"noreferrer"}
                        href={contact.value}
                        className="dark:text-gray-200 font-regular text-sm text-right"
                      >
                        {contact.value}
                      </a>
                    )}
                  </Row>
                </Box>
              ))}
            </Row>
          </Box>
        </Row>
      </main>
    </React.Fragment>
  );
}

export default App;
